import { type QueryClient } from '@tanstack/react-query';
import { REACT_QUERY_KEYS, type Cart } from '@hungryroot/rest';

export function updateCart(client: QueryClient, cart: Cart) {
  client.setQueryData([REACT_QUERY_KEYS.CART], cart);
}
